// extracted by mini-css-extract-plugin
export default {"newUiHatText":"hfkqfE","newUiCurrentPlanHatText":"tBNcqr"};